import './Home.css';
import Info from '../components/info/Info';
import SEO from '../components/seo/SEO';
import NamingLoop from '../components/python/NamingLoop';


function Home() {


  return (
    <>
      <SEO
        title="Home | Explorelrt"
        description="Explorelrt shares technology updates, practical resources, and learning material for curious readers."
      />

      <main className="homePage">

        <NamingLoop />

        <Info />
  
      </main>
    </>
  );
}

export default Home;
